import api from "../../utils/ApiConfig";

export const fetchLockedAccounts = async () => {
  const response = await api.get("/bo/locked-accounts");
  return response.data;
};

export const unlockAccount = async (id) => {
  const response = await api.post(`/bo/locked-accounts/${id}/unlock`);
  return response.data;
};
